import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IDisplayElement } from '../interfaces/test-header-elements.interface';
import { Observable } from 'rxjs/Observable';
import { TEST_META_ACTIONS } from '../constants/test-meta.constants';

@Injectable()
export class TestMetaActionCreatorService {
  private store$: any;

  constructor(store$: Store<any>) {
    this.store$ = store$.select('tests', 'meta', 'config');
  }

  getDisplayConfig(key: string): Observable<Array<IDisplayElement> | null> {
    return this.store$.select('displayElements')
      .take(1)
      .map(data => {
        if (!data.has(key)) {
          return null;
        } else {
          return data.get(key);
        }
      });
  }

  setDisplayConfig(key: string, config: IDisplayElement): void {
    this.store$.dispatch({
      type: TEST_META_ACTIONS.SET_HEADER_DISPLAY_CONFIG,
      payload: {
        elementName: key,
        config
      }
    });
  }
}
